<template>
  <nav
    id="navbar"
    class="navbar navbar-expand navbar-light bg-light border-bottom border-dark w-100 sticky-top"
    style="z-index: 3000;"
  >
    <div class="container-fluid">
      <a class="navbar-brand" href="#">G</a>
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mx-auto my-2 my-lg-0 fw-bold text-sm">
          <li class="nav-item mx-2">
            <router-link :active-class="'active bg-primary rounded text-white'" class="nav-link" to="/" @click="emitCalendarShown">
              PANEL ZADAŃ
            </router-link>
          </li>
          <li class="nav-item mx-2">
            <router-link :active-class="'active bg-primary rounded text-white'" class="nav-link" to="/magazyn" @click="emitStorehouseShown">
              MAGAZYN
            </router-link>
          </li>
          <li class="nav-item mx-2">
            <router-link :active-class="'active bg-primary rounded text-white'" class="nav-link" to="/kierowcy" @click="emitDriverListingShown">
              KIEROWCY
            </router-link>
          </li>
          <li class="nav-item mx-2">
            <router-link :active-class="'active bg-primary rounded text-white'" class="nav-link" to="/zlecenia" @click="emitTasksListShown">
              ZLECENIA
            </router-link>
          </li>
          <li class="nav-item mx-2">
            <router-link :active-class="'active bg-primary rounded text-white'" class="nav-link" to="/miejsca" @click="emitPlacesShown">
              MIEJSCA
            </router-link>
          </li>
          <li class="nav-item mx-2">
            <router-link :active-class="'active bg-primary rounded text-white'" class="nav-link" to="/report" @click="emitReportsShown">
              RAPORTY
            </router-link>
          </li>
          <li class="nav-item mx-2">
            <router-link :active-class="'active bg-primary rounded text-white'" class="nav-link" to="/user" @click="emitUsersShown">
              UŻYTKOWNICY
            </router-link>
          </li>
          <li class="nav-item mx-2">
            <router-link :active-class="'active bg-primary rounded text-white'" class="nav-link" to="/vehicles-filter" @click="emitVehiclesFilterShown">
              KOLEJNOŚĆ CIĄGNIKÓW
            </router-link>
          </li>
        </ul>

        <ul class="navbar-nav ml-auto mb-2 mb-lg-0 fw-bold text-sm">
          <li class="nav-item ms-2 me-5">
            <div class="dropdown">
              <button class="btn btn-light text-secondary dropdown-toggle" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                <i class="fas fa-user"></i>
                {{ username }}
              </button>
              <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                <li><a class="dropdown-item" href="#" @click="logout">Wyloguj</a></li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import Swal from 'sweetalert2'
import axios from 'axios'
import emitter from '@/modules/events/emitter'
import eventKinds from '@/modules/events/eventKinds'

export default {
  name: 'Navbar',
  data () {
    return {
      isUserLoggedIn: false,
      username: null
    }
  },
  computed: {
    currentRoute () {
      return this.$route.name
    }
  },

  created () {
    this.username = localStorage.getItem('username')
  },
  methods: {
    logout () {
      localStorage.removeItem('accessToken')
      localStorage.removeItem('username')
      localStorage.removeItem('email')
      localStorage.removeItem('permissions')
      this.isUserLoggedIn = false
      this.$router.push('/login').then(() => Swal.fire('Pomyślnie wylogowano użytkownika', 'Twoja sesja użytkownika została pomyślnie zakończona', 'success'))
    },

    emitCalendarShown () {
      emitter.emit(eventKinds.calendarShown)
    },

    emitTasksListShown () {
      emitter.emit(eventKinds.tasksListShown)
    },

    emitStorehouseShown () {
      emitter.emit(eventKinds.storehouseShown)
    },

    emitDriverListingShown () {
      emitter.emit(eventKinds.driverListingShown)
    },

    emitPlacesShown () {
      emitter.emit(eventKinds.placesShown)
    },

    emitReportsShown () {
      emitter.emit(eventKinds.reportsShown)
    },

    emitUsersShown () {
      emitter.emit(eventKinds.usersShown)
    },

    emitVehiclesFilterShown () {
      emitter.emit(eventKinds.vehiclesFilterShown)
    }
  }
}
</script>

<style scoped>
.text-sm {
  font-size: .8rem;
}

.text-xl {
  font-size: 1.2rem;
}

@media (max-width: 1500px) {
  #navbar {
    min-width: 1500px;
  }
}
</style>
